const ERROR_403_EXPIRED_CWT_TOKEN_RESPONSE = { error_code: 50, message: 'Forbidden' };

export const IGNORED_ERROR_RESPONSES: Record<string, unknown>[] = [ERROR_403_EXPIRED_CWT_TOKEN_RESPONSE];
